import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Label } from '../Label/component.js';
import { NavListItem as _NavListItem } from '../NavListItem/component.js';
var NavListGroup = function NavListGroup(_ref) {
  var title = _ref.title,
    navListItems = _ref.navListItems,
    onItemClick = _ref.onItemClick;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !!title && /*#__PURE__*/React.createElement(Label, {
    label: title
  }), navListItems.map(function (navListItem, index) {
    return /*#__PURE__*/React.createElement(_NavListItem, _extends({
      key: index,
      onItemClick: onItemClick
    }, navListItem));
  }));
};
export { NavListGroup };